import React from 'react';
import { WarningIcon, CheckIcon, XIcon } from '@phosphor-icons/react';
import './confirm-modal.css';

interface ConfirmModalProps {
  isOpen: boolean;
  title?: string;
  message: string;
  confirmText?: string;
  cancelText?: string;
  confirmVariant?: 'primary' | 'danger' | 'warning';
  onConfirm: () => void;
  onCancel: () => void;
  isLoading?: boolean;
}

const ConfirmModal: React.FC<ConfirmModalProps> = ({
  isOpen,
  title = 'Conferma azione',
  message,
  confirmText = 'Conferma',
  cancelText = 'Annulla',
  confirmVariant = 'primary',
  onConfirm,
  onCancel,
  isLoading = false
}) => {
  if (!isOpen) return null;

  const handleKeyDown = (e: React.KeyboardEvent) => {
    if (e.key === 'Escape') {
      onCancel();
    }
    if (e.key === 'Enter') {
      onConfirm();
    }
  };

  const getIcon = () => {
    switch (confirmVariant) {
      case 'danger':
        return <WarningIcon size={24} weight="fill" className="confirm-modal-icon danger" />;
      case 'warning':
        return <WarningIcon size={24} weight="fill" className="confirm-modal-icon warning" />;
      default:
        return <CheckIcon size={24} weight="fill" className="confirm-modal-icon primary" />;
    }
  };

  return (
    <div
      className="confirm-modal-overlay"
      role="dialog"
      aria-modal="true"
      onClick={onCancel}
      onKeyDown={handleKeyDown}
    >
      <div
        className="confirm-modal-content"
        role="document"
        onClick={(e) => e.stopPropagation()}
        onKeyDown={(e) => e.stopPropagation()}
      >
        <div className="confirm-modal-header">
          <div className="confirm-modal-title-with-icon">
            {getIcon()}
            <h3>{title}</h3>
          </div>
          <button
            className="confirm-modal-close"
            onClick={onCancel}
            disabled={isLoading}
          >
            <XIcon size={20} weight="bold" />
          </button>
        </div>
        
        <div className="confirm-modal-body">
          <p>{message}</p>
        </div>
        
        <div className="confirm-modal-actions">
          <button
            className="confirm-modal-button secondary"
            onClick={onCancel}
            disabled={isLoading}
          >
            {cancelText}
          </button>
          <button
            className={`confirm-modal-button ${confirmVariant}`}
            onClick={onConfirm}
            disabled={isLoading}
          >
            {isLoading ? 'Caricamento...' : confirmText}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmModal;